import { render, staticRenderFns } from "./QilinPet.vue?vue&type=template&id=34aa906a&scoped=true&"
import script from "./QilinPet.vue?vue&type=script&lang=js&"
export * from "./QilinPet.vue?vue&type=script&lang=js&"
import style0 from "./QilinPet.vue?vue&type=style&index=0&id=34aa906a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa906a",
  null
  
)

export default component.exports